/* eslint-disable no-unused-vars */
import _bpms from '@/js/mob';
var _main = {
  _template: {
    menu:
      '<li> \n' +
      "    <span class='count' style='display:none'> \n" +
      "        <em id='count'>0</em> \n" +
      '    </span> \n' +
      '    <a> \n' +
      "         <i id='menuIcon' class=''></i> \n" +
      "         <em id='menuNm' class='desc'>메뉴명</em> \n" +
      '    </a> \n' +
      '</li> \n',
    layerMenu1:
      '<li> \n' +
      '    <a> \n' +
      "        <i id='menuIcon' class=''></i> \n" +
      "        <em id='menuNm'></em> \n" +
      '    </a> \n' +
      "    <span class='li_count' style='display:none'> \n" +
      "        <em id='count'>0</em> \n" +
      '    </span> \n' +
      '</li> \n',
    layerMenu2:
      "<li class='menu_sub'> \n" +
      '    <a> \n' +
      "         <span id='menuNm' class='fa-solid fa-angle-right'></span> \n" +
      '    </a> \n' +
      '</li> \n',
    pageWrap: "<div class='m_contents'></div>",
  },

  /**
   * 페이지 관련 정보
   */
  page: {
    selected: {},
    navigate: [],
  },
  /**
   * 메뉴 목록
   */
  menu: {
    list: [],
  },
  /**
   * 메인 초기 설정
   */
  initMain: function () {
    // 메뉴 만들기
    _main.makeMenu();

    // 레이어 메뉴 이벤트
    _main.bindEventLayerMenu();

    // home 버튼
    $('.btn_home').on('click', _main.goHome);

    // 나가기 버튼
    $('.btn_out').on('click', _main.goIBGF);

    /***** TOP 이동 버튼 *****/
    $('.go_top').on('click', function () {
      $('html, body').animate({ scrollTop: 0 }, 500);
    });

    // 스크롤 시 보였다가 스크롤이 엄추면 2초 후 사라짐
    var toptimeout = 0;
    $(document).scroll(function (e) {
      $('.go_top').show();

      // 기존 효과 초기화
      $('.go_top').stop();
      $('.go_top').css('opacity', 1);
      clearTimeout(toptimeout);

      // 2초후 사라짐
      toptimeout = setTimeout(function () {
        $('.go_top').fadeOut(1000);
      }, 2000);
    });
  },

  /**
   * 메뉴 만들기
   */
  makeMenu: function () {
    _bpms.ajax(
      '/menu/list',
      null,
      function (resData) {
        _main.page.list = resData;

        // 1레벨 메뉴
        $.each(resData, async function (i, menu) {
          // console.log(JSON.stringify(menu));
          if (menu.menuCd == 'BPUR0400') {
            _main.oriPageData = menu;
          }
          _main.addMenu(menu); // 메인에 메뉴 추가
          _main.addLayerMenu(menu); // 레이어 메뉴에 추가
        });
      },
      { async: false },
    );

    // 메뉴 개수 세팅
    _main.setAllMenuCount();
  },
  /**
   * 홈으로 이동
   */
  goHome: function () {
    /*
        _main.page.selected = {};
        _main.page.navigate = [];
        $(".m_contents").not("#page_main").remove();
        $(".m_contents").show();
        */

    location.href = '/' + location.search;
  },
  /**
   * iBGF 로 이동
   */
  goIBGF: function () {
    var url = 'exit_webview';
    location.href = url;
  },

  /**
   * 메인 메뉴 추가
   *
   * @param obj 메뉴가 추가될 영역
   * @param menu 메뉴 정보
   */
  addMenu: function (menu) {
    var wrap = $('.menu_box ul');
    var menuObj = $(_main._template.menu);

    if (
      menu.menuCd.startsWith('TEST') == true ||
      menu.menuCd.startsWith('SMPL') == true
    ) {
      return;
    }

    // 메뉴정보 화면 세팅
    _main.setMenuInfo(wrap, menuObj, menu);

    // 메뉴 클릭
    menuObj.find('a').on('click', function () {
      _main.addPage(menu);
    });

    // 메뉴 wrap 에 메뉴 추가
    wrap.append(menuObj);
  },

  /**
   * 레이어 메뉴 추가
   */
  addLayerMenu: function (menu) {
    var wrap = $('.menu_wrap ul');

    var menuObj = null;
    if (menu.menuLevel == '1') {
      menuObj = $(_main._template.layerMenu1);

      // 메뉴 wrap 에 메뉴 추가
      wrap.append(menuObj);

      // 2레벨 메뉴 추가
      $.each(menu.childList, function (i, menu2) {
        _main.addLayerMenu(menu2);
      });
    } else if (menu.menuLevel == '2') {
      menuObj = $(_main._template.layerMenu2);

      // 메뉴 wrap 에 메뉴 추가
      wrap.append(menuObj);
    }

    // 메뉴정보 화면 세팅
    _main.setMenuInfo(wrap, menuObj, menu);

    // 메뉴 클릭
    if (!menu.childList) {
      menuObj.on('click', function () {
        _main.toggleLayerMenu(function () {
          _main.addPage(menu);
        });
      });
    }
  },

  /**
   * 메뉴 정보 메뉴 화면에 세팅
   */
  setMenuInfo: function (wrap, menuObj, menu) {
    // menu 객체에 pageCd 세팅
    menuObj.attr('menuCd', menu.menuCd);

    // 메뉴명
    if (menu.menuLevel == 1) {
      menuObj.find('#menuNm').text(menu.menuNm);
    } else if (menu.menuLevel == 2) {
      menuObj.find('#menuNm').after(menu.menuNm);
    }

    // 메뉴 아이콘
    menuObj.find('#menuIcon').addClass(menu.menuIcon);

    // 메뉴 데이터 개수
    if (menu.countYn == 'Y') {
      menuObj.find('.count').show();
      menuObj.find('.li_count').show();
    }
  },

  oriPageData: {},
  pageData: {},

  /**
   * 메뉴 이동
   */
  addPage: function (menu) {
    //console.log(JSON.stringify(menu));
    _main.pageData = menu;

    // 이미 선택된 페이지가 다시 선택되면 return
    var selectedPage = _main.page.selected;
    if (
      selectedPage != undefined &&
      menu.pageCd == _main.page.selected.pageCd
    ) {
      return;
    }

    // 네비게이터 초기화
    _main.page.navigate = [];

    var url = menu.url || '';
    if (url.startsWith('script:')) {
      var fn = url.replace('script:', '');
      _bpms.callback(fn, menu);
    } else {
      var options = {
        dataType: 'html',
        async: false,
      };
      var data = {
        menuCd: menu.menuCd,
        pageCd: menu.pageCd,
        url: menu.url,
      };
      _bpms.ajax(
        '/menu/page',
        data,
        function (resData) {
          // 기존 페이지 숨기기, 메인 제외하고 삭제
          $('.m_contents').hide();
          $('.m_contents').not('#page_main').remove();

          // 페이지 붙이기
          var pageObj = $(_main._template.pageWrap)
            .attr('id', 'page_' + menu.pageCd)
            .append(resData);
          $('.m_container').append(pageObj);

          // 스크롤바 위로
          $(document).scrollTop(0);

          // 페이지 제목 세팅
          pageObj.find('.m_top h2').text(menu.pageNm);

          // 페이지 뒤로가기 버튼
          pageObj.find('.btn_prev').on('click', function () {
            _main.goPrev();
          });

          // 선택한 페이지 세팅
          _main.page.selected = menu;

          // 네비게이트에 추가
          _main.page.navigate.push(_main.page.selected);

          // 하단 버튼
          _main.setFooterButton();
        },
        options,
      );
    }
  },

  /**
   * SR 팝업 open
   */
  openSR: function (menu) {
    $('#layerSR').removeClass('dpn');
  },
  /**
   * SR 팝업 닫기
   */
  closeSR: function () {
    $('#layerSR').addClass('dpn');
  },
  /**
   * 레이어 메뉴 이벤트 bind
   */
  bindEventLayerMenu: function () {
    // 레이어 메뉴 버튼
    $('#btnLayerMenu').on('click', _main.toggleLayerMenu);

    // 레이어 메뉴 닫기 버튼
    $('#layerMenu #btnCloseLayerMenu').on('click', _main.toggleLayerMenu);
  },
  /**
   * 레이어 메뉴  toggle
   */
  toggleLayerMenu: function (complete) {
    $('#layerMenu').toggle({
      direction: 'left',
      effect: 'blind',
      complete: complete,
    });
  },
  /**
   * 뒤로가기
   */
  goPrev: function () {
    // 네비게이트의 마지막 삭제
    _main.page.navigate.pop();

    // 현재 페이지(네비게이터의 마지막 페이지 삭제 및 마지막 페이지)
    var curPage = _main.page.selected;

    // 현재 페이지 삭제
    $('#page_' + curPage.pageCd).remove();

    // 이전 페이지 보이기
    var prevPage =
      _main.page.navigate.length == 0
        ? {}
        : _main.page.navigate[_main.page.navigate.length - 1];
    var prevPageId =
      _main.page.navigate.length == 0
        ? '#page_main'
        : '#page_' + prevPage.pageCd;
    $(prevPageId).show();

    // 이전 페이지를 현재 페이지로 삭제
    _main.page.selected = prevPage;

    // 하단 버튼
    _main.setFooterButton();

    //$(".m_container").scrollTop(0);
    if (_main.page.navigate.length == 0) {
      $(document).scrollTop(0);
    } else {
      $(document).scrollTop(_main.scrollTop);
    }
  },

  /**
   * 메뉴 데이터 개수를 세팅하는 모든 메뉴의 데이터 개수를 세팅
   */
  setAllMenuCount: function (callback) {
    var menuCds = _bpms.getHasMenuCountMenu();
    menuCds.forEach(async function (menuCd) {
      _bpms.getMenuCount(menuCd, function (count) {
        _main.setMenuCount(menuCd, count);
        _bpms.callback(callback, { menuCd: menuCd, count: count });
      });
    });
  },

  /**
   * 메뉴 데이터 개수 세팅
   */
  setMenuCount: function (menuCd, count) {
    // 받은 업무 메뉴
    if (menuCd == 'BPUR0200') {
      // 모바일 받은 업무 개수 조회
      _bpms.ajax(
        '/bpur/bpur0200/countMobileTodo',
        {},
        function (mobileCount) {
          // 구 BPM 받은 업무 개수 조회
          _bpms.getOldTodoCount(function (oldCount) {
            $("#page_main li[menuCd='" + menuCd + "'] #count").text(
              count + oldCount + '(' + mobileCount + ')',
            );
            $("#layerMenu li[menuCd='" + menuCd + "'] #count").text(
              count + oldCount + '(' + mobileCount + ')',
            );
          });
        },
        { async: false },
      );
    }
    // 받은 업무 외 메뉴
    else {
      $("#page_main li[menuCd='" + menuCd + "'] #count").text(count);
      $("#layerMenu li[menuCd='" + menuCd + "'] #count").text(count);
    }
  },

  /**
   * 하단 버튼 체크
   */
  setFooterButton: function () {
    var button = _bpms.getElement('.btn_reg_wrap, .btn_sch_wrap2, .sr_area');

    // 하단에 버튼이 있는지 여부
    if (button.length == 0) {
      $('.m_container').css('padding-bottom', 0);
    } else {
      $('.m_container').css('padding-bottom', 60);
    }
  },

  test: async function (a, b, c) {
    alert(a);
    alert(b);
    alert(c);
  },
};
export default _main;
